module.exports = __webpack_public_path__ + "static/media/05.6d82dbc4.mp3";